import React from "react";
import { ThemeProvider, createMuiTheme } from "@material-ui/core";

const shared = {
  palette: {
    primary: {
      main: "#35C974",
    },
    secondary: {
      main: "#00E676",
    },
  },
};

const theme = createMuiTheme({
  ...shared,
  direction: "rtl",

  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
});

const theme_ltr = createMuiTheme({
  ...shared,
  direction: "ltr",
  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
});

const theme_dark = createMuiTheme({
  ...shared,
  direction: "rtl",
  palette: {
    ...shared.palette,
    type: "dark",
  },
  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
});

const theme_dark_ltr = createMuiTheme({
  ...shared,
  direction: "ltr",
  palette: {
    ...shared.palette,
    type: "dark",
  },
  typography: {
    fontFamily: '"Fa_IRANSans", serif',
  },
});

export default function MaterialThemeProvider(props) {
  const forceLtr = props.forceLtr || false;
  const [selectedColor, setSelectedColor] = React.useState("light");
  const selectedTheme =
    selectedColor === "light"
      ? forceLtr
        ? theme_ltr
        : theme
      : forceLtr
      ? theme_dark_ltr
      : theme_dark;
  selectedTheme.toggleDarkMode = () => {
    setSelectedColor(selectedColor === "light" ? "dark" : "light");
  };
  return <ThemeProvider theme={selectedTheme}>{props.children}</ThemeProvider>;
}
